import { VariablesModalRoute } from './VariablesModalRoute';

export const CustomVariablesModalRoute = () => (
  <VariablesModalRoute triggerRoute="customVariables" modalRoute="customVariable" />
);

export const BuiltInVariablesModalRoute = () => (
  <VariablesModalRoute triggerRoute="builtInVariables" modalRoute="builtInVariable" />
);
